var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.781,
    height: 140.25,
    viewBox: "0 0 94.781 140.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M36.844-80.25H51.281q10.313,0,15.281-5.156t4.969-13.687q0-8.25-4.922-12.844t-13.547-4.594a19.994,19.994,0,0,0-13.031,4.266,13.639,13.639,0,0,0-5.25,11.109H7.688a33.32,33.32,0,0,1,5.766-19.172,38.42,38.42,0,0,1,16.125-13.266,53.816,53.816,0,0,1,22.828-4.781q21.656,0,33.938,10.359T98.625-99.469a28.722,28.722,0,0,1-5.719,17.25,37.154,37.154,0,0,1-15,12.094Q89.438-66,95.109-57.75a33.569,33.569,0,0,1,5.672,19.5q0,18.188-13.266,29.156T52.406,1.875q-20.437,0-33.422-10.781T6-37.406H33.094a15.7,15.7,0,0,0,5.766,12.563,21.246,21.246,0,0,0,14.2,4.875q9.656,0,15.141-5.109t5.484-13.547q0-20.437-22.5-20.437H36.844Z",
    transform: "translate(-6 138.375)",
    fill: "#f37320",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.1d78a54800c72a0c5ede7c69bac59445.svg";
export { ForwardRef as ReactComponent };